import React from 'react';
import globalStore from '@services/global.state';
import {getUrlParams} from '@components/utils';
import {goTo} from '@utils';
import {HomeGameCardItem} from '@/pages/home/home.type';
import BaseImageCard from './base-image-card';

const DiceCards = ({v}: {i: number; v: HomeGameCardItem}) => {
  return (
    <BaseImageCard
      imageUrl={v.gamePic}
      backgroundSize="contain"
      onClick={() => {
        globalStore.updateAmount.next({gameType: 'Dice'});
        const params = getUrlParams(v.gameUrl);
        params.cycle = v.clcyle;
        goTo('Dice', params);
      }}
    />
  );
};

export default DiceCards;
